import { Controller } from "stimulus";

export default class extends Controller {
  static values = { text: String };

  copy(event) {
    event.preventDefault();
    const text =
      this.textValue || this.element.getAttribute("data-clipboard-text") || "";
    if (!text) return;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(() => this.flash());
    } else {
      const temp = document.createElement("textarea");
      temp.value = text;
      document.body.appendChild(temp);
      temp.select();
      try {
        document.execCommand("copy");
      } catch (e) {}
      document.body.removeChild(temp);
      this.flash();
    }
  }

  flash() {
    this.element.classList.add("btn-success");
    this.element.classList.remove("btn-outline-secondary");
    const original = this.element.innerHTML;
    this.element.innerHTML = "Copied";
    setTimeout(() => {
      this.element.classList.remove("btn-success");
      this.element.classList.add("btn-outline-secondary");
      this.element.innerHTML = original;
    }, 1200);
  }
}
